import { Component } from '@angular/core';

@Component({
    selector: 'app-config-all',
    templateUrl: './config-all.component.html',
    styleUrls: ['./config-all.component.scss'],
})
export class ConfigAllComponent {}
